import apiService from '../../../apiService'
import Notification from '../../../../../../../../resources/js/notification'

export default {
  namespaced: true,
  state: {
    total: 0,
    domains: []
  },
  mutations: {
    setTotal (state, payload) {
      state.total = payload
    },
    setDomains (state, payload) {
      state.domains = payload
    }
  },
  actions: {
    fetch ({ commit }) {
      apiService.getClientAgreements()
        .then(response => {
          commit('setTotal', response.data.agreements.total)
          commit('setDomains', response.data.agreements.domains)
          window.vue.$emit('clientAgreementsLoaded')
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить список согласований.'
          })
        })
    }
  }
}
